import { getAmountAndTickerFromInputSelector } from "@kubera/common";

export const CELL_MODE_DATA_ATTRIBUTE_KEY = "data-cell-mode";

export const cellMode = {
  SELECT: "select",
  EDIT: "edit",
  UPDATE: "update"
};

export const gridDragGripPadding = "0 20px 0 0";

export const gridCellPadding = {
  DEFAULT: "7px",
  WITH_CHANGE_INDICATOR: "15px",
  SINGLE_CELL: "15px"
};

export const gridCellEdgeInset = "10px";

const isLeadingCellProp = ({ isLeadingCell, $isLeadingCell }) => isLeadingCell === true || $isLeadingCell === true;

const isSingleCellProp = ({ isSingleCellRow, $isSingleCellRow }) =>
  isSingleCellRow === true || $isSingleCellRow === true;

export const getGridCellPaddingRight = props =>
  isSingleCellProp(props)
    ? gridCellPadding.SINGLE_CELL
    : props.hasChangeIndicator === true || props.$hasChangeIndicator === true
    ? gridCellPadding.WITH_CHANGE_INDICATOR
    : gridCellPadding.DEFAULT;

export const getGridCellPaddingLeft = props =>
  isSingleCellProp(props) ? gridCellPadding.SINGLE_CELL : gridCellPadding.DEFAULT;

export const getGridCellMarginLeft = props =>
  isLeadingCellProp(props) && isSingleCellProp(props) === false ? gridCellEdgeInset : "0px";

export const getGridCellContentOffsetLeft = props =>
  isSingleCellProp(props)
    ? gridCellPadding.SINGLE_CELL
    : isLeadingCellProp(props)
    ? `calc(${gridCellPadding.DEFAULT} + ${gridCellEdgeInset})`
    : gridCellPadding.DEFAULT;

export const buildPasteStringWithCurrency = (state, pastedText, cellCurrency, fallbackCurrency) => {
  const currency = cellCurrency || fallbackCurrency;
  const parsed = getAmountAndTickerFromInputSelector(state, pastedText.trim(), currency);
  return currency + " " + (parsed.value ?? "");
};
